import { useNavigate } from "react-router-dom";
import ReactInputMask from "react-input-mask";
import FileBase64 from "../../components/FileBase64";
import { useEffect, useState } from "react";
import Joi from "joi";

import "./style.css";
import { api } from "../../api/api";
import { filtered } from "../../utils/listaFaculcades";
import { Toast } from "../../utils/toast";

const ESTADOS_BRASILEIROS = [
  { sigla: "AC", nome: "Acre" },
  { sigla: "AL", nome: "Alagoas" },
  { sigla: "AP", nome: "Amapá" },
  { sigla: "AM", nome: "Amazonas" },
  { sigla: "BA", nome: "Bahia" },
  { sigla: "CE", nome: "Ceará" },
  { sigla: "DF", nome: "Distrito Federal" },
  { sigla: "ES", nome: "Espírito Santo" },
  { sigla: "GO", nome: "Goiás" },
  { sigla: "MA", nome: "Maranhão" },
  { sigla: "MT", nome: "Mato Grosso" },
  { sigla: "MS", nome: "Mato Grosso do Sul" },
  { sigla: "MG", nome: "Minas Gerais" },
  { sigla: "PA", nome: "Pará" },
  { sigla: "PB", nome: "Paraíba" },
  { sigla: "PR", nome: "Paraná" },
  { sigla: "PE", nome: "Pernambuco" },
  { sigla: "PI", nome: "Piauí" },
  { sigla: "RJ", nome: "Rio de Janeiro" },
  { sigla: "RN", nome: "Rio Grande do Norte" },
  { sigla: "RS", nome: "Rio Grande do Sul" },
  { sigla: "RO", nome: "Rondônia" },
  { sigla: "RR", nome: "Roraima" },
  { sigla: "SC", nome: "Santa Catarina" },
  { sigla: "SP", nome: "São Paulo" },
  { sigla: "SE", nome: "Sergipe" },
  { sigla: "TO", nome: "Tocantins" },
];

const DOCUMENTOS_OBRIGATORIOS = [
  { key: "rg", label: "RG (frente)" },
  { key: "rg-verso", label: "RG (verso)" },
  { key: "cpf", label: "CPF" },
  { key: "compResi", label: "comprovante de residência" },
  {
    key: "compResiOrigem",
    label: "comprovante de residência da cidade de origem",
  },
  {
    key: "declaração-ensino-medio-escola-publica",
    label: "declaração da escola",
  },
];

function getRegistrationErrorMessage(error) {
  const response = error?.response;
  const data = response?.data;
  const validationMessage =
    data?.errors?.[0]?.message || data?.erros?.[0]?.message;

  if (validationMessage) return validationMessage;
  if (data?.message || data?.messsage) return data.message || data.messsage;

  if (response?.status === 413) {
    return "Um dos documentos excede o tamanho permitido.";
  }

  if (!response) {
    return "Não foi possível conectar ao servidor. Verifique sua internet e tente novamente.";
  }

  return "Não foi possível concluir o cadastro. Tente novamente ou entre em contato com o suporte.";
}

export function Register() {
  const navigate = useNavigate();
  const [user, setUser] = useState({
    name: "",
    cpf: "",
    senha: "",
    rg: "",
    telefone: "",
    email: "",
    endereco: "",
    numero: "",
    bairro: "",
    cidade: "",
    cep: "",
    dataNascimento: "",
    documents: [],
    oldSchool: "",
    isSchoolPublic: "Escola pública",
    isResideForaVicosa: "Não",
    isStudentOfOmega: "Não",
    isOldStudentOfOmega: "Não",
    nameOldSchool: "",
    cityOldSchool: "Viçosa",
    faculdadesEscolhidas: [],
    cursosEscolhido: [],
    instagram: "",
  });

  const [faculdadeEscolhida, setFaculdadeEscolhida] = useState("");
  const [cursoEscolhido, setCursoEscolhido] = useState("");
  const [state, setState] = useState("MG");
  const [cities, setCities] = useState(null);

  function setDocument(document) {
    setUser((currentUser) => ({
      ...currentUser,
      documents: [
        ...currentUser.documents.filter(({ key }) => key !== document.key),
        document,
      ],
    }));
  }

  async function register() {
    const body = {
      cpf: user.cpf,
      rg: user.rg,
      name: user?.name,
      birthDate: user.dataNascimento,
      password: user.senha,
      email: user.email,
      phone: user.telefone,
      cep: user.cep,
      address: user.endereco,
      number: user.numero,
      district: user.bairro,
      city: user.cidade,
      isSchoolPublic: user.isSchoolPublic === "Escola pública",
      isResideForaVicosa: user.isResideForaVicosa === "Sim",
      isStudentOfOmega: user.isStudentOfOmega === "Sim",
      isOldStudentOfOmega: user.isOldStudentOfOmega === "Sim",
      documents: user.documents,
      nameOldSchool: user.nameOldSchool,
      cityOldSchool: user.cityOldSchool,
      faculdadesEscolhidas: user.faculdadesEscolhidas,
      cursosEscolhido: user.cursosEscolhido,
      instagram: user.instagram,
    };

    const validation = Joi.object({
      name: Joi.string().label("Nome").required().messages({
        "string.base": "O nome deve ser uma string.",
        "any.required": "O nome é obrigatório.",
      }),
      email: Joi.string()
        .label("E-mail")
        .email({ tlds: { allow: false } })
        .required()
        .messages({
          "string.base": "O e-mail deve ser uma string.",
          "string.email": "O e-mail deve ser válido.",
          "any.required": "O e-mail é obrigatório.",
        }),
      phone: Joi.string().label("Telefone").required().messages({
        "string.base": "O telefone deve ser uma string.",
        "any.required": "O telefone é obrigatório.",
      }),
      address: Joi.string().label("Endereço").required().messages({
        "string.base": "O endereço deve ser uma string.",
        "any.required": "O endereço é obrigatório.",
      }),
      cep: Joi.string().label("CEP").required().messages({
        "string.base": "O CEP deve ser uma string.",
        "any.required": "O CEP é obrigatório.",
      }),

      number: Joi.string().label("Número").required().messages({
        "string.base": "O número deve ser uma string.",
        "any.required": "O número é obrigatório.",
      }),
      district: Joi.string().label("Bairro").required().messages({
        "string.base": "O bairro deve ser uma string.",
        "any.required": "O bairro é obrigatório.",
      }),
      city: Joi.string().label("Cidade").required().messages({
        "string.base": "A cidade deve ser uma string.",
        "any.required": "A cidade é obrigatória.",
      }),
      cpf: Joi.string().label("CPF").required().messages({
        "string.base": "O CPF deve ser uma string.",
        "any.required": "O CPF é obrigatório.",
      }),
      rg: Joi.string().label("RG").required().messages({
        "string.base": "O RG deve ser uma string.",
        "any.required": "O RG é obrigatório.",
      }),

      birthDate: Joi.date().label("Data de nascimento").required().messages({
        "date.base": "A data de nascimento deve ser uma data válida.",
        "any.required": "A data de nascimento é obrigatória.",
      }),
      password: Joi.string().label("Senha").required().messages({
        "string.base": "A senha deve ser uma string.",
        "any.required": "A senha é obrigatória.",
      }),
      isSchoolPublic: Joi.boolean().label("é de escola publica?").messages({
        "boolean.base": 'O campo "é de escola publica" deve ser Sim ou Não.',
      }),
      isResideForaVicosa: Joi.boolean().messages({
        "boolean.base": 'O campo "Reside fora de Viçosa" deve ser Sim ou Não.',
      }),
      isStudentOfOmega: Joi.boolean().messages({
        "boolean.base": 'O campo "Estudante do omega" deve ser Sim ou Não.',
      }),
      isOldStudentOfOmega: Joi.boolean().messages({
        "boolean.base": 'O campo "Ex estudante do omega" deve ser Sim ou Não.',
      }),
      documents: Joi.array().items(Joi.any()),
      faculdadesEscolhidas: Joi.array().items(Joi.string()),
      cursosEscolhido: Joi.array().items(Joi.string()),
      instagram: Joi.string().allow(null, ""),
    });

    const { error } = validation.validate(body, {
      allowUnknown: true,
      messages: {
        "string.empty": "O campo {{#label}} é obrigatório",
      },
    });

    if (error?.details?.length > 0) {
      console.log(error.details[0].message);
      return Toast.warning(
        error.details[0].message ||
        "Tem campos obrigatórios a serem preenchidos.",
        "Validação",
      );
    }

    const missingDocuments = DOCUMENTOS_OBRIGATORIOS.filter(
      ({ key }) => !body.documents.some((document) => document.key === key),
    );

    if (missingDocuments.length > 0) {
      return Toast.warning(
        `Anexe os seguintes documentos: ${missingDocuments
          .map(({ label }) => label)
          .join(", ")}.`,
        "Documentos obrigatórios",
      );
    }

    try {
      const response = await api.post("/api/v1/users/student", body, {
        skipGlobalErrorToast: true,
      });

      localStorage.setItem("token", response.data.token.token);
      navigate("/home");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      return Toast.warning(
        getRegistrationErrorMessage(error),
        "Não foi possível criar o cadastro",
      );
    }
  }

  async function getCitiesByState() {
    try {
      const response = await api.get(
        `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${state}/distritos`,
      );
      setCities(
        response.data.map((e) => {
          return {
            nome: e.nome,
            id: e.id,
          };
        }),
      );
    } catch (error) {
      console.error("Erro ao buscar cidades:", error);
      return [];
    }
  }

  useEffect(() => {
    if (state) {
      getCitiesByState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return (
    <>
      <div className="login-form register-page">
        <main className="register-shell">
          <div>
            <header className="register-header">
              <img src="/img/omega.7041f9d3.png" alt="Cursinho Ômega" />
              <span className="register-eyebrow">Portal do aluno</span>
              <h1>Crie seu cadastro</h1>
              <p>
                Preencha seus dados para começar sua jornada com o Cursinho
                Ômega.
              </p>
            </header>

            <section className="row register-section">
              <div className="col-sm-12">
                <div className="section-heading">
                  <span>01</span>
                  <div>
                    <h2>Dados do aluno</h2>
                    <p>Informações pessoais e de contato.</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-4 mb-2">
                <label htmlFor="">Nome</label>
                <input
                  type="text"
                  value={user.name}
                  onChange={(e) => setUser({ ...user, name: e.target.value })}
                  placeholder="Nome completo"
                  className="form-control form-control-sm"
                />
              </div>
              <div className="col-sm-4 mb-2">
                <label htmlFor="">E-mail</label>
                <input
                  type="email"
                  value={user.email}
                  onChange={(e) => setUser({ ...user, email: e.target.value })}
                  placeholder="E-mail"
                  className="form-control form-control-sm"
                />
              </div>
              <div className="col-sm-4 mb-2">
                <label htmlFor="">Telefone</label>
                <ReactInputMask
                  mask="(99) 9 9999-9999"
                  className="form-control form-control-sm"
                  placeholder="Digite seu telefone"
                  value={user.telefone}
                  onChange={(e) =>
                    setUser({ ...user, telefone: e.target.value })
                  }
                />
              </div>
              <div className="col-sm-4 mb-2">
                <label htmlFor="">Endereço</label>
                <input
                  type="text"
                  value={user.endereco}
                  onChange={(e) =>
                    setUser({ ...user, endereco: e.target.value })
                  }
                  placeholder="Endereço"
                  className="form-control form-control-sm"
                />
              </div>
              <div className="col-sm-2 mb-2">
                <label htmlFor="">Número</label>
                <input
                  type="text"
                  value={user.numero}
                  onChange={(e) => setUser({ ...user, numero: e.target.value })}
                  placeholder="Número"
                  className="form-control form-control-sm"
                />
              </div>
              <div className="col-sm-3 mb-2">
                <label htmlFor="">Bairro</label>
                <input
                  type="text"
                  value={user.bairro}
                  onChange={(e) => setUser({ ...user, bairro: e.target.value })}
                  placeholder="Bairro"
                  className="form-control form-control-sm"
                />
              </div>
              <div className="col-sm-3 mb-2">
                <label htmlFor="">Cidade</label>
                <input
                  type="text"
                  value={user.cidade}
                  onChange={(e) => setUser({ ...user, cidade: e.target.value })}
                  placeholder="Cidade"
                  className="form-control form-control-sm"
                  list="cities-list"
                />
                <datalist id="cities-list">
                  {cities?.map((city) => (
                    <option key={city.id} value={city.nome} />
                  ))}
                </datalist>
              </div>
              <div className="col-sm-3 mb-2">
                <label htmlFor="">Cep</label>
                <ReactInputMask
                  mask="99999-999"
                  className="form-control form-control-sm"
                  placeholder="Digite seu cep"
                  value={user.cep}
                  onChange={(e) => setUser({ ...user, cep: e.target.value })}
                />
              </div>
              <div className="col-sm-3 mb-2">
                <label htmlFor="">Data Nascimento</label>
                <input
                  type="date"
                  value={user.dataNascimento}
                  onChange={(e) =>
                    setUser({ ...user, dataNascimento: e.target.value })
                  }
                  className="form-control form-control-sm"
                />
              </div>
              <div className="col-sm-3 mb-2">
                <label htmlFor="">CPF</label>
                <ReactInputMask
                  mask="999.999.999-99"
                  className="form-control form-control-sm"
                  value={user.cpf}
                  onChange={(e) => setUser({ ...user, cpf: e.target.value })}
                />
              </div>
              <div className="col-sm-3 mb-2">
                <label htmlFor="">Senha</label>
                <input
                  type="password"
                  value={user.senha}
                  onChange={(e) => setUser({ ...user, senha: e.target.value })}
                  placeholder="Senha"
                  className="form-control form-control-sm"
                />
              </div>
              <div className="col-sm-3 mb-2">
                <label htmlFor="">RG</label>
                <input
                  type="text"
                  value={user.rg}
                  onChange={(e) => setUser({ ...user, rg: e.target.value })}
                  placeholder="RG"
                  className="form-control form-control-sm"
                />
              </div>
              <div className="col-sm-4 mb-2">
                <label htmlFor="">Você estuda/estudou em:</label>
                <select
                  className="form-control form-control-sm"
                  value={user.isSchoolPublic}
                  onChange={(e) =>
                    setUser({ ...user, isSchoolPublic: e.target.value })
                  }
                  aria-label="Default select example"
                >
                  <option value="Escola pública">Escola pública</option>
                  <option value="Escola particular">Escola particular</option>
                </select>
              </div>

              <div className="col-sm-4 mb-2">
                <label htmlFor="">Você é aluno do Cursinho/Colégio ômega:</label>
                <select
                  value={user.isStudentOfOmega}
                  onChange={(e) =>
                    setUser({ ...user, isStudentOfOmega: e.target.value })
                  }
                  className="form-control form-control-sm"
                  aria-label="Default select example"
                >
                  <option value="Sim">Sim</option>
                  <option value="Não">Não</option>
                </select>
              </div>

              <div className="col-sm-4 mb-2">
                <label htmlFor="">Ex aluno Ômega (Cursinho/Colégio):</label>
                <select
                  value={user.isOldStudentOfOmega}
                  onChange={(e) =>
                    setUser({ ...user, isOldStudentOfOmega: e.target.value })
                  }
                  className="form-control form-control-sm"
                >
                  <option value="Sim">Sim</option>
                  <option value="Não">Não</option>
                </select>
              </div>
              <div className="col-sm-4 mb-2">
                <label htmlFor="">Reside fora de viçosa:</label>
                <select
                  value={user.isResideForaVicosa}
                  onChange={(e) =>
                    setUser({ ...user, isResideForaVicosa: e.target.value })
                  }
                  className="form-control form-control-sm"
                >
                  <option value="Sim">Sim</option>
                  <option value="Não">Não</option>
                </select>
              </div>
              <div className="col-sm-3 mb-2">
                <label htmlFor="">Instagram</label>
                <input
                  type="text"
                  value={user.instagram}
                  onChange={(e) =>
                    setUser({ ...user, instagram: e.target.value })
                  }
                  placeholder="instagram"
                  className="form-control form-control-sm"
                />
              </div>
            </section>

            <section className="row register-section choice-section">
              <div className="col-sm-12">
                <div className="section-heading">
                  <span>02</span>
                  <div>
                    <h2>Interesses acadêmicos</h2>
                    <p>
                      Conte quais faculdades e cursos estão nos seus planos.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-5 mb-2">
                <label htmlFor="">Quais faculdades pretender cursar?:</label>
                <input
                  type="text"
                  value={faculdadeEscolhida || ""}
                  onChange={(e) => setFaculdadeEscolhida(e.target.value)}
                  className="form-control form-control-sm"
                  list="faculdades-list"
                  placeholder="Selecione"
                />
                <datalist id="faculdades-list">
                  {filtered(faculdadeEscolhida || "").map((faculdade) => (
                    <option
                      key={faculdade.sigla}
                      value={`${faculdade.sigla}-${faculdade.nome}-${faculdade.estado}`}
                    >
                      {faculdade.nome}
                    </option>
                  ))}
                </datalist>

                <button
                  className="btn btn-sm btn-primary mt-2"
                  onClick={() => {
                    if (!faculdadeEscolhida) {
                      Toast.warning("Selecione a faculdade por favor");
                      return;
                    }

                    setUser({
                      ...user,
                      faculdadesEscolhidas: [
                        ...user.faculdadesEscolhidas,
                        faculdadeEscolhida,
                      ],
                    });

                    setFaculdadeEscolhida("");
                  }}
                >
                  Adicionar
                </button>
              </div>

              <div className="col-sm-6 choice-list">
                {user.faculdadesEscolhidas.map((e, i) => {
                  return (
                    <div className="choice-item" key={`${e}-${i}`}>
                      <span>{i + 1}</span>
                      <p>{e}</p>
                    </div>
                  );
                })}
                {user.faculdadesEscolhidas.length === 0 && (
                  <p className="choice-empty">
                    As faculdades adicionadas aparecerão aqui.
                  </p>
                )}
              </div>

              <div className="col-sm-5 mb-2">
                <label htmlFor="">Quais cursos pretender cursar?:</label>
                <input
                  type="text"
                  value={cursoEscolhido || ""}
                  onChange={(e) => setCursoEscolhido(e.target.value)}
                  className="form-control form-control-sm"
                  placeholder="Selecione"
                />
                <button
                  className="btn btn-sm btn-primary mt-2"
                  onClick={() => {
                    if (!cursoEscolhido) {
                      Toast.warning("Digite o nome um curso por favor");
                      return;
                    }
                    setUser({
                      ...user,
                      cursosEscolhido: [
                        ...user.cursosEscolhido,
                        cursoEscolhido,
                      ],
                    });

                    setCursoEscolhido("");
                  }}
                >
                  Adicionar
                </button>
              </div>

              <div className="col-sm-6 choice-list">
                {user.cursosEscolhido.map((e, i) => {
                  return (
                    <div className="choice-item" key={`${e}-${i}`}>
                      <span>{i + 1}</span>
                      <p>{e}</p>
                    </div>
                  );
                })}
                {user.cursosEscolhido.length === 0 && (
                  <p className="choice-empty">
                    Os cursos adicionados aparecerão aqui.
                  </p>
                )}
              </div>
            </section>

            <section className="row register-section">
              <div className="col-sm-12">
                <div className="section-heading">
                  <span>03</span>
                  <div>
                    <h2>Escola anterior</h2>
                    <p>Informe onde você estuda ou estudou.</p>
                  </div>
                </div>
              </div>

              <div className="col-sm-12">
                <label htmlFor="">Nome da escola</label>
                <input
                  type="text"
                  value={user.nameOldSchool}
                  onChange={(e) =>
                    setUser({ ...user, nameOldSchool: e.target.value })
                  }
                  className="form form-control form-control-sm"
                />
              </div>

              <div className="col-sm-6 mt-3">
                <label htmlFor="">Estado</label>
                <select
                  onChange={(e) => {
                    setState(e.target.value);
                  }}
                  className="form form-control form-control-sm"
                  aria-label="Default select example"
                >
                  {ESTADOS_BRASILEIROS.map((estado) => {
                    return (
                      <option
                        key={estado.sigla}
                        value={estado.sigla}
                        selected={estado.sigla === "MG"}
                      >
                        {estado.nome}-{estado.sigla}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="col-sm-6 mt-3">
                <label htmlFor="">Cidade da escola</label>
                <input
                  type="text"
                  value={user.cityOldSchool}
                  onChange={(e) =>
                    setUser({ ...user, cityOldSchool: e.target.value })
                  }
                  className="form form-control form-control-sm"
                  list="cities-old-school-list"
                />
                <datalist id="cities-old-school-list">
                  {cities?.map((city) => (
                    <option key={city.id} value={city.nome} />
                  ))}
                </datalist>
              </div>
            </section>

            <section className="row register-section documents-section">
              <div className="col-sm-12">
                <div className="section-heading">
                  <span>04</span>
                  <div>
                    <h2>Documentos</h2>
                    <p>
                      Anexe os seis documentos necessários para concluir o
                      cadastro.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mt-3">
                <label>RG (Frente)</label>
                <br />
                <FileBase64
                  multiple={false}
                  onDone={function (e) {
                    setDocument({
                      base64: `${e.base64}`,
                      name: e.name,
                      key: "rg",
                    });
                  }}
                />
              </div>
              <div className="col-sm-6 mt-3">
                <label>RG (Verso)</label>
                <br />
                <FileBase64
                  multiple={false}
                  onDone={function (e) {
                    setDocument({
                      base64: `${e.base64}`,
                      name: e.name,
                      key: "rg-verso",
                    });
                  }}
                />
              </div>
              <div className="col-sm-6 mt-3">
                <label>CPF</label>
                <br />

                <FileBase64
                  multiple={false}
                  onDone={function (e) {
                    setDocument({
                      base64: `${e.base64}`,
                      name: e.name,
                      key: "cpf",
                    });
                  }}
                />
              </div>
              <div className="col-sm-6 mt-3">
                <label>Comprovante Residência</label>
                <br />
                <FileBase64
                  multiple={false}
                  onDone={function (e) {
                    setDocument({
                      base64: `${e.base64}`,
                      name: e.name,
                      key: "compResi",
                    });
                  }}
                />
              </div>
              <div className="col-sm-6 mt-3">
                <label>Comprovante Residência (Cidade de origem)</label>
                <br />
                <FileBase64
                  multiple={false}
                  onDone={function (e) {
                    setDocument({
                      base64: `${e.base64}`,
                      name: e.name,
                      key: "compResiOrigem",
                    });
                  }}
                />
              </div>
              <div className="col-sm-6 mt-3">
                <label>Declaração da escola que estuda/estudou</label>
                <br />
                <FileBase64
                  multiple={false}
                  onDone={function (e) {
                    setDocument({
                      base64: `${e.base64}`,
                      name: e.name,
                      key: "declaração-ensino-medio-escola-publica",
                    });
                  }}
                />
              </div>
            </section>

            <div className="register-actions">
              <button className="btn btn-primary" onClick={() => register()}>
                Criar meu cadastro
              </button>
              <button
                className="btn btn-outline-primary"
                onClick={() => navigate("/")}
              >
                Voltar para o login
              </button>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}
